<template>
    <!--layout3   13 专题-->
    <div class="special-box">
        <div class="special-box-wrap">
            <div v-if="index == 0" class="special-box-wrap-first" @click="goDetail(dataItem)">
                <img :src="dataItem.cover_img" alt="" />
                <div class="special-box-wrap-first-bot">
                    <div>
                        <span class="desc">{{ dataItem.created_at }}</span>
                    </div>
                </div>
                <div class="special-box-wrap-first-icon">
                </div>
            </div>
            <div v-else class="special-box-wrap-other" :class="[index == 1 ? 'chu': '']" @click="goDetail(dataItem)">
                <img :src="dataItem.cover_img" alt="" />
                <div class="special-box-wrap-other-bot">
                    <div>{{ dataItem.title }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Interface from '@/util/interface'

export default {
    props: {
        dataItem: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        }
    },

    methods: {

        goDetail(dataItem) {
            this.$router.push({ name: 'topic-detail', params: { id: dataItem.origin_id } })
            Interface.getData('get', `/course-phase/api/recommend_v2/${dataItem.origin_id}/view`)
            Interface.getData('get', `/course/api/content_relation/${dataItem.origin_id}/view`)
            Interface.mFootPrint(dataItem.origin_id,13,0,5,0, dataItem.title)
        },
    }
}
</script>

<style lang="scss" scoped>
.special-box{
    &-wrap{
        display: inline-block;
        &:nth-child(2n){
            margin-right: 11px;
        }
        &-first{
            position: relative;
            width: 331px;
            height: 184px;
            margin-top: 6px;
            img{
                width: 100%;
                height: 184px;
                border-radius: 6px;
            }
            &-bot{
                position: absolute;
                bottom: 0px;
                width: 100%;
                padding-bottom: 10px;
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
                div:nth-child(1){
                    font-size: 16px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #FFFFFF;
                    padding-left: 14px;
                }
                div:nth-child(2){
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 8px;
                    color: #fff;
                    font-size: 12px;
                    font-family: HarmonyOS_Sans_SC;
                    color: #FFFFFF;
                    padding: 0 14px 0 14px;
                    .desc{
                        font-size: 12px;
                        font-family: HarmonyOS_Sans_SC;
                        color: #FFFFFF;
                        line-height: 18px;
                    }
                    .apply{
                        width: 94px;
                        height: 32px;
                    }
                }
            }
            &-bg{
                position: absolute;
                left: 0;
                bottom: 0;
                width: 331px;
                height: 100px;
                background: linear-gradient(180deg, rgba(34,34,34,0) 0%, rgba(0,0,0,0.2) 40%, rgba(0,0,0,0.5) 100%);
                border-radius: 0px 0px 6px 6px;
            }
            &-icon{
                position: absolute;
                left: 3px;
                top:4px;
                img{
                    width: 54px;
                    height: 18px;
                    border-radius: 4px;
                }
            }
        }
        &-other{
            display: inline-block;
            position: relative;
            width: 160px;
            margin-top: 14px;
            img{
                width: 100%;
                height: 90px;
                border-radius: 6px;
            }
            &-bot{
                width: 100%;
                float: left;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                margin-top: 9px;
                div:nth-child(1){
                    font-size: 14px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #222222;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp:2;
                }
                div:nth-child(2){
                    // margin-top: 10px;
                    .desc{
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #979797;
                    }
                }
            }
            &-icon{
                position: absolute;
                left: 4px;
                top: 4px;
                img{
                    width: 30px;
                    height: 18px;
                    border-radius: 4px;
                }
            }
        }
        .chu{
            margin-right: 11px;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/hotRecommend/layout3/special.vue